import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-message-component',
  templateUrl: './message-component.component.html',
  styleUrls: ['./message-component.component.scss']
})
export class MessageComponentComponent {

  @Input()
  public title: string = 'Title';

  @Output()
  public closeButtonClicked = new EventEmitter<any>();


  public onCloseButtonClick() : void {
    this.closeButtonClicked.emit();
  }

}
